import { Button } from '@toggle/design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import {
  AssetDetails,
  EarningState,
  Expectation,
} from '@/api/asset/asset-schema';
import { getEarningState } from '@/utils/asset/assetUtils';

export interface OpenDrawerButtonProps {
  assetDetails: AssetDetails;
  expectation?: Expectation;
  historyMetaCount?: number;
  onClick?: () => void;
}

const translationKeys = {
  [Expectation.Beat]: 'earnings:openDrawerBeats',
  [Expectation.Miss]: 'earnings:openDrawerMisses',
  [Expectation.Meet]: 'earnings:openDrawerMeet',
  [EarningState.Beat]: 'earnings:openDrawerBeats',
  [EarningState.Miss]: 'earnings:openDrawerMisses',
  [EarningState.Meet]: 'earnings:openDrawerMeet',
};

export const getTranslationKey = (
  reported: boolean,
  earningState?: EarningState,
  expectation?: Expectation
) => {
  if (!reported && expectation) {
    return translationKeys[expectation];
  }

  if (reported && earningState) {
    return translationKeys[earningState];
  }

  return '';
};

export const OpenDrawerButton = ({
  assetDetails,
  expectation,
  historyMetaCount,
  onClick,
}: OpenDrawerButtonProps) => {
  const earningState = getEarningState(assetDetails.eps);
  const { t } = useTranslation('earnings');

  const translationKey = getTranslationKey(
    assetDetails.reported,
    earningState,
    expectation
  );

  return (
    <Button
      data-testid="dig-into-button"
      type="button"
      size="small"
      label={t(translationKey, {
        count: historyMetaCount,
      })}
      onClick={onClick}
    />
  );
};
